import { IconButton, Tooltip } from "@mui/material";
import { Settings } from "@mui/icons-material";
import { FC } from "react";
import { useAppDataContext } from "@context/AppContext";

const OpenSettingsButton: FC = () => {
  const { openSettingsDialog } = useAppDataContext();
  return (
    <Tooltip title={"Einstellungen"}>
      <span>
        <IconButton onClick={openSettingsDialog}>
          <Settings />
        </IconButton>
      </span>
    </Tooltip>
  );
};

export default OpenSettingsButton;
